/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceAccountCredentialsBaseForOci extends models.ServiceAccountCredentialsBase {
    constructor() {
        super();
        this.setDiscriminator("ServiceAccountCredentialsBaseForOci");
    }

    getFixupPrototypeFunction() { return ServiceAccountCredentialsBaseForOci.fixupPrototype; }

    static newInstance(model: Partial<ServiceAccountCredentialsBaseForOci>): ServiceAccountCredentialsBaseForOci {
        let obj = Object.assign(new ServiceAccountCredentialsBaseForOci(), model);
        ServiceAccountCredentialsBaseForOci.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceAccountCredentialsBaseForOci>): ServiceAccountCredentialsBaseForOci {
        if (!model) return null;
        return ServiceAccountCredentialsBaseForOci.newInstance(<ServiceAccountCredentialsBaseForOci> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceAccountCredentialsBaseForOci) {
        if (!obj) return;

        models.ServiceAccountCredentialsBaseForOci.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceAccountCredentialsBaseForOci): boolean {
        if (models.ServiceAccountCredentialsBase.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ServiceAccountCredentialsBaseForOci.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

}
